import {useDispatch, useSelector} from "react-redux";
import {selectMap} from "../../features/counter/counterSlice";
import generateTocForCurrentPath from "../../components/TableOfContents/tocGeneration";
import {setTableOfContents} from "../../features/tableOfContents/TableOfContentsSlice";
import {useEffect} from "react";
import {isSameItem} from "./tableOfContents";

export function useTableOfContentsItems(menuItem) {
  const dartMap = useSelector(selectMap);
  const dispatch = useDispatch();
  const { tableOfContents } = useSelector(
    (state) => state.tableOfContents,
  );

  useEffect(() => {
    const tocItems = generateTocForCurrentPath(dartMap, menuItem);
    if (!isSameItem(tocItems, tableOfContents)) {
      dispatch(setTableOfContents(tocItems));
    }
  }, [dartMap, menuItem, dispatch]);
}
